import React from "react";

export default function PrivacyPolicy() {
  return (
    <iframe
      title="Privacy Policy"
      src="/Privicy-policy.html"
      style={{
        width: "100%",
        height: "100vh",
        border: "none",
      }}
    />
  );
}
